let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCBzK")).then(() => parcelRequire('cC2Jo'));